export default __webpack_public_path__ + "static/media/xmas-how-mobile.cae93231.jpg";